import { rem } from 'polished'
import styled from 'styled-components'

export const FeedContentStyled = styled.div`
  font-size: ${rem(16)};
`
